import React from 'react'
import './ui.css'

const Skeleton = ({ rows = 3, avatar = false, title = false, className = '', label }) => (
  <div
    className={`ui-skeleton ${className}`}
    data-testid="skeleton"
    aria-hidden={label ? undefined : 'true'}
    role={label ? 'status' : undefined}
    aria-label={label || undefined}
    aria-busy="true"
  >
    {(avatar || title) && (
      <div className="ui-skeleton-head">
        {avatar && <span className="ui-skeleton-avatar" />}
        {title && (
          <div className="ui-skeleton-lines ui-skeleton-lines--narrow">
            <span className="ui-skeleton-line" />
            <span className="ui-skeleton-line ui-skeleton-line--short" />
          </div>
        )}
      </div>
    )}
    <div className="ui-skeleton-lines">
      {Array.from({ length: Math.max(1, rows) }).map((_, i) => (
        <span key={i} className="ui-skeleton-line" />
      ))}
    </div>
  </div>
)

export default Skeleton
